import { useMutation, useQueryClient } from '@common-fe/common-fe';
import { toNumber } from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { QUERY_KEY as PAYOUT_DEFINITIONS_QUERY_KEY } from '@/modules/core/queries/usePayoutDefinition.query';
import { useCurrentOrganisationStore } from '@/modules/core/store';

import {
  CreatePayoutDefinitionPayload,
  PayoutDefinitionResponse,
} from '../CreatePayoutDefinitionModal.types';

const useCreatePayoutDefinitionQuery = () => {
  const { organizationId } = useCurrentOrganisationStore();
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (payload: CreatePayoutDefinitionPayload) =>
      api.post<PayoutDefinitionResponse>(API_URL.PAYOUT_DEFINITIONS, {
        name: payload.name,
        organization_id: organizationId ? toNumber(organizationId) : null,
        ...(payload.copyFromId ? { parent_id: toNumber(payload.copyFromId) } : {}),
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [PAYOUT_DEFINITIONS_QUERY_KEY] });
      },
    }
  );

  return mutation;
};

export default useCreatePayoutDefinitionQuery;
